import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AdHost } from '@common/admin/ads/ad-host';
import { FloatingLinkOverlay } from '@app/short-links/floating-link-overlay';
export function LinkOverlayRenderer({ link }) {
    return (_jsxs("div", { className: "flex flex-col h-screen relative", children: [_jsx(AdHost, { slot: "frame", className: "my-20" }), link.overlay && _jsx(FloatingLinkOverlay, { overlay: link.overlay }), _jsx("iframe", { src: link.long_url, className: "flex-auto" })] }));
}
